import React from 'react';
import {NavLink} from 'react-router-dom';
import '../../styles/designs/Logo.css';

import nichewareLogoS from '../../images/logo/logo192.png';
import nichewareLogoL from '../../images/logo/logo512.png';

const Logo = ({
  variant = 'name',
  size = 'medium',
  subtext = 'Custom Software Solutions',
  mode = 'light',
}) => {
  const showName = variant === 'full' || variant === 'name';
  const showSubtext = variant === 'full';

  const logoSrc = size === 'large' ? nichewareLogoL : nichewareLogoS;

  return (
    <>
      <NavLink to='/home' className={`logo-container logo-${size}`}>
        <div className="logo-icon-container">
          <img
            className="logo-icon"
            src={logoSrc}
            alt="NicheWare logo"
            draggable={false}
          />
        </div>

        {showName && (
          <div className={`logo-text-container logo-text-container-${size}${showSubtext ? ' logo-text-full' : ' logo-text-name'}`}>
            <p className={`logo-name logo-name-${size}`}>
              <span className="niche">Niche</span><span className="ware">Ware</span>
            </p>

            {showSubtext && (
              <p className={`logo-subtext logo-subtext-${size}`}>{subtext}</p>
            )}
          </div>
        )}
    </NavLink>
    </>

  );
};

export default Logo;
